// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../public/SiteIcons/creditIcon.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../../../public/SiteIcons/expireIcon.svg");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../../../../public/SiteIcons/cvvIcon.svg");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../../../../public/SiteIcons/zipCodeIcon.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment-container-izO8o {
	width: 100%;
	max-width: var(--max-listing-width);
	margin: 0 auto;
}

.Payment-titleText-SjjCe {
	font-size: 24px;
	font-weight: 600;
	margin: 0;
}

.Payment-houseRules-cw7Vy {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Payment-backgroundCover-AVpTS {
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	background-color: var(--primary-border);
	border-radius: 6px;
}

.Payment-bannerImage-ZbrHv {
	padding-top: 54%;
	position: relative;
}

.Payment-horizondalLine-K82vJ {
	margin: 24px 0px;
	border-top: 1px solid var(--primary-border);
	height: auto;
}

.Payment-hrLineSidePanelMargin-vIs5J {
	margin: 18px 0px;
}

.Payment-cancelBtn-wDQ57 {
	margin-right: 23px;
}

.Payment-disabledLink-OOWrp {
	pointer-events: none;
	cursor: default;
	opacity: 0.6;
}

.Payment-specialPriceText-MWQ1B {
	display: inline-block;
	vertical-align: middle;
}

.Payment-specialPriceIcon-pISuE {
	display: inline-block;
	position: relative;
}

.Payment-specialPriceIcon-pISuE:hover .Payment-toolTip-JwlKt {
	display: block;
}

.Payment-toolTip-JwlKt {
	position: absolute;
	top: -48px;
	right: 0;
	left: 0px;
	display: none;
	background: var(--common-text-color);
	min-width: 280px;
	text-align: center;
	padding: 10px;
	border-radius: 4px;
	color: var(--white-text);
}

.Payment-toolTipRelativeSection-WRmr1::after {
	content: '';
	height: 100%;
	width: 100%;
	position: absolute;
	left: 10px;
	right: 0;
	top: 34px;
	bottom: 0;
	text-align: center;
	background-color: var(--common-text-color);
	z-index: 1;
	max-width: 11px;
	max-height: 11px;
	-webkit-transform: rotate(136deg);
	    -ms-transform: rotate(136deg);
	        transform: rotate(136deg);
}

.Payment-faqImage-DqGn9 {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin-right: 5px;
}

.Payment-starFlex-TRWm_ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Payment-tableFlex-_iSsr {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Payment-cancellationSectionPayment-CGiXw {
	padding: 26px;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.Payment-stripeImg-eLAcU {
	max-width: 170px;
}

.Payment-cardSection-cCIm5 {
	padding: 30px;
	border-radius: 12px;
	border: 1px solid var(--primary-border);
	display: grid;
	gap: 24px;
}

.Payment-creditCardForm-s5jf1 {
	padding: 30px;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.Payment-avatarImageGrid-EflCh {
	display: grid;
	grid-template-columns: 80px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Payment-textSection-reejy {
	margin-left: 20px;
}

.Payment-displayGridFirstName-LVTlT {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 18px 12px;
}

.Payment-dateFiledGrid-c2HG2 {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 18px 12px;
}

.Payment-datePadding-wP8XP {
	padding: 0px 24px;
}

.Payment-datePanelSection-qb5ol {
	background-color: var(--common-gray-bg-color);
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	padding: 24px;
}

.Payment-flexWrap-calvJ {
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.Payment-arrowMargin-fcWUZ {
	margin: 0px 15px 0px 15px;
}

.Payment-paymentFlexDirection-j3uXI {
	-webkit-box-orient: horizontal;
	-webkit-box-direction: normal;
	    -ms-flex-direction: row;
	        flex-direction: row;
}

/* new */

.Payment-stripCardInputContainer-AFy8k {
	position: relative;
}

.Payment-stripCardAccountInput-eikia::after,
.Payment-stripCardExpiryInput-CiCpB::after,
.Payment-stripCardCvvInput-KFWXA::after,
.Payment-stripCardOPostalInput-RNoYH::after {
	content: '';
	position: absolute;
	top: 0px;
	bottom: 0px;
	right: 13px;
	width: 100%;
	max-width: 22px;
	z-index: 0;
}

.Payment-stripCardAccountInput-eikia::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: 100%;
}

.Payment-stripCardExpiryInput-CiCpB::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-repeat: no-repeat;
	background-position: 100%;
}

.Payment-stripCardCvvInput-KFWXA::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-repeat: no-repeat;
	background-position: 100%;
}

.Payment-stripCardOPostalInput-RNoYH::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	background-repeat: no-repeat;
	background-position: 100%;
}

.Payment-stripCardOPostalInput-RNoYH input {
	display: block;
	width: 100%;
	padding: 13px 45px 13px 20px;
	font-size: 16px;
	line-height: 22px;
	background-image: none;
	border-radius: 6px;
	height: 48px;
	color: var(--common-text-color);
	border: 1px solid var(--primary-border);
	background-color: var(--primary-white-bg);
	text-align: start;
}

.Payment-stripCardGridBox-c67fQ {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
}

.Payment-gap12-kFn06 {
	gap: 12px;
}

@media screen and (max-width: 991px) {
	.Payment-paymentFlexDirection-j3uXI {
		-webkit-box-orient: vertical;
		-webkit-box-direction: reverse;
		    -ms-flex-direction: column-reverse;
		        flex-direction: column-reverse;
	}
}

@media screen and (max-width: 767px) {
	.Payment-toolTip-JwlKt {
		top: 29px;
		min-width: 250px;
	}

	.Payment-toolTipRelativeSection-WRmr1::after {
		right: 0;
		top: -3px;
	}

	.Payment-displayGridFirstName-LVTlT,
	.Payment-dateFiledGrid-c2HG2 {
		grid-template-columns: 100%;
	}

	.Payment-datePadding-wP8XP {
		padding: 24px 0px;
	}

	.Payment-cvvNoPadding-brapW {
		padding: 0px 0px;
	}

	.Payment-cardSection-cCIm5 {
		gap: 18px;
		padding: 18px;
	}

	.Payment-stripCardGridBox-c67fQ {
		grid-template-columns: 100%;
		gap: 18px;
	}

}`, "",{"version":3,"sources":["webpack://./src/components/Booking/Payment/Payment.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,kCAAkC;CAClC,4BAA4B;CAC5B,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,2CAA2C;CAC3C,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,aAAa;CACb,oCAAoC;CACpC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,0CAA0C;CAC1C,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uCAAuC;CACvC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,6CAA6C;CAC7C,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8BAAmB;CAAnB,6BAAmB;KAAnB,uBAAmB;SAAnB,mBAAmB;AACpB;;AAEA,QAAQ;;AAER;CACC,kBAAkB;AACnB;;AAEA;;;;CAIC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,WAAW;CACX,WAAW;CACX,eAAe;CACf,UAAU;AACX;;AAEA;CACC,yDAAoE;CACpE,4BAA4B;CAC5B,yBAAyB;AAC1B;;AAEA;CACC,yDAAoE;CACpE,4BAA4B;CAC5B,yBAAyB;AAC1B;;AAEA;CACC,yDAAiE;CACjE,4BAA4B;CAC5B,yBAAyB;AAC1B;;AAEA;CACC,yDAAqE;CACrE,4BAA4B;CAC5B,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,WAAW;CACX,4BAA4B;CAC5B,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,+BAA+B;CAC/B,uCAAuC;CACvC,yCAAyC;CACzC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,qCAAqC;AACtC;;AAEA;CACC,SAAS;AACV;;AAEA;CACC;EACC,4BAA8B;EAA9B,8BAA8B;MAA9B,kCAA8B;UAA9B,8BAA8B;CAC/B;AACD;;AAEA;CACC;EACC,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,QAAQ;EACR,SAAS;CACV;;CAEA;;EAEC,2BAA2B;CAC5B;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,SAAS;EACT,aAAa;CACd;;CAEA;EACC,2BAA2B;EAC3B,SAAS;CACV;;AAED","sourcesContent":[".container {\n\twidth: 100%;\n\tmax-width: var(--max-listing-width);\n\tmargin: 0 auto;\n}\n\n.titleText {\n\tfont-size: 24px;\n\tfont-weight: 600;\n\tmargin: 0;\n}\n\n.houseRules {\n\tdisplay: flex;\n}\n\n.backgroundCover {\n\tbackground-size: cover;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-color: var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.bannerImage {\n\tpadding-top: 54%;\n\tposition: relative;\n}\n\n.horizondalLine {\n\tmargin: 24px 0px;\n\tborder-top: 1px solid var(--primary-border);\n\theight: auto;\n}\n\n.hrLineSidePanelMargin {\n\tmargin: 18px 0px;\n}\n\n.cancelBtn {\n\tmargin-right: 23px;\n}\n\n.disabledLink {\n\tpointer-events: none;\n\tcursor: default;\n\topacity: 0.6;\n}\n\n.specialPriceText {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.specialPriceIcon {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.specialPriceIcon:hover .toolTip {\n\tdisplay: block;\n}\n\n.toolTip {\n\tposition: absolute;\n\ttop: -48px;\n\tright: 0;\n\tleft: 0px;\n\tdisplay: none;\n\tbackground: var(--common-text-color);\n\tmin-width: 280px;\n\ttext-align: center;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tcolor: var(--white-text);\n}\n\n.toolTipRelativeSection::after {\n\tcontent: '';\n\theight: 100%;\n\twidth: 100%;\n\tposition: absolute;\n\tleft: 10px;\n\tright: 0;\n\ttop: 34px;\n\tbottom: 0;\n\ttext-align: center;\n\tbackground-color: var(--common-text-color);\n\tz-index: 1;\n\tmax-width: 11px;\n\tmax-height: 11px;\n\ttransform: rotate(136deg);\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n}\n\n.starFlex {\n\tdisplay: flex;\n}\n\n.tableFlex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.cancellationSectionPayment {\n\tpadding: 26px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.stripeImg {\n\tmax-width: 170px;\n}\n\n.cardSection {\n\tpadding: 30px;\n\tborder-radius: 12px;\n\tborder: 1px solid var(--primary-border);\n\tdisplay: grid;\n\tgap: 24px;\n}\n\n.creditCardForm {\n\tpadding: 30px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.avatarImageGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 80px auto;\n\talign-items: center;\n}\n\n.textSection {\n\tmargin-left: 20px;\n}\n\n.displayGridFirstName {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 18px 12px;\n}\n\n.dateFiledGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgap: 18px 12px;\n}\n\n.datePadding {\n\tpadding: 0px 24px;\n}\n\n.datePanelSection {\n\tbackground-color: var(--common-gray-bg-color);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 24px;\n}\n\n.flexWrap {\n\tflex-wrap: wrap;\n}\n\n.arrowMargin {\n\tmargin: 0px 15px 0px 15px;\n}\n\n.paymentFlexDirection {\n\tflex-direction: row;\n}\n\n/* new */\n\n.stripCardInputContainer {\n\tposition: relative;\n}\n\n.stripCardAccountInput::after,\n.stripCardExpiryInput::after,\n.stripCardCvvInput::after,\n.stripCardOPostalInput::after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0px;\n\tbottom: 0px;\n\tright: 13px;\n\twidth: 100%;\n\tmax-width: 22px;\n\tz-index: 0;\n}\n\n.stripCardAccountInput::after {\n\tbackground-image: url('../../../../public/SiteIcons/creditIcon.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: 100%;\n}\n\n.stripCardExpiryInput::after {\n\tbackground-image: url('../../../../public/SiteIcons/expireIcon.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: 100%;\n}\n\n.stripCardCvvInput::after {\n\tbackground-image: url('../../../../public/SiteIcons/cvvIcon.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: 100%;\n}\n\n.stripCardOPostalInput::after {\n\tbackground-image: url('../../../../public/SiteIcons/zipCodeIcon.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: 100%;\n}\n\n.stripCardOPostalInput input {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 13px 45px 13px 20px;\n\tfont-size: 16px;\n\tline-height: 22px;\n\tbackground-image: none;\n\tborder-radius: 6px;\n\theight: 48px;\n\tcolor: var(--common-text-color);\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: var(--primary-white-bg);\n\ttext-align: start;\n}\n\n.stripCardGridBox {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n}\n\n.gap12 {\n\tgap: 12px;\n}\n\n@media screen and (max-width: 991px) {\n\t.paymentFlexDirection {\n\t\tflex-direction: column-reverse;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.toolTip {\n\t\ttop: 29px;\n\t\tmin-width: 250px;\n\t}\n\n\t.toolTipRelativeSection::after {\n\t\tright: 0;\n\t\ttop: -3px;\n\t}\n\n\t.displayGridFirstName,\n\t.dateFiledGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.datePadding {\n\t\tpadding: 24px 0px;\n\t}\n\n\t.cvvNoPadding {\n\t\tpadding: 0px 0px;\n\t}\n\n\t.cardSection {\n\t\tgap: 18px;\n\t\tpadding: 18px;\n\t}\n\n\t.stripCardGridBox {\n\t\tgrid-template-columns: 100%;\n\t\tgap: 18px;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Payment-container-izO8o`,
	"titleText": `Payment-titleText-SjjCe`,
	"houseRules": `Payment-houseRules-cw7Vy`,
	"backgroundCover": `Payment-backgroundCover-AVpTS`,
	"bannerImage": `Payment-bannerImage-ZbrHv`,
	"horizondalLine": `Payment-horizondalLine-K82vJ`,
	"hrLineSidePanelMargin": `Payment-hrLineSidePanelMargin-vIs5J`,
	"cancelBtn": `Payment-cancelBtn-wDQ57`,
	"disabledLink": `Payment-disabledLink-OOWrp`,
	"specialPriceText": `Payment-specialPriceText-MWQ1B`,
	"specialPriceIcon": `Payment-specialPriceIcon-pISuE`,
	"toolTip": `Payment-toolTip-JwlKt`,
	"toolTipRelativeSection": `Payment-toolTipRelativeSection-WRmr1`,
	"faqImage": `Payment-faqImage-DqGn9`,
	"starFlex": `Payment-starFlex-TRWm_`,
	"tableFlex": `Payment-tableFlex-_iSsr`,
	"cancellationSectionPayment": `Payment-cancellationSectionPayment-CGiXw`,
	"stripeImg": `Payment-stripeImg-eLAcU`,
	"cardSection": `Payment-cardSection-cCIm5`,
	"creditCardForm": `Payment-creditCardForm-s5jf1`,
	"avatarImageGrid": `Payment-avatarImageGrid-EflCh`,
	"textSection": `Payment-textSection-reejy`,
	"displayGridFirstName": `Payment-displayGridFirstName-LVTlT`,
	"dateFiledGrid": `Payment-dateFiledGrid-c2HG2`,
	"datePadding": `Payment-datePadding-wP8XP`,
	"datePanelSection": `Payment-datePanelSection-qb5ol`,
	"flexWrap": `Payment-flexWrap-calvJ`,
	"arrowMargin": `Payment-arrowMargin-fcWUZ`,
	"paymentFlexDirection": `Payment-paymentFlexDirection-j3uXI`,
	"stripCardInputContainer": `Payment-stripCardInputContainer-AFy8k`,
	"stripCardAccountInput": `Payment-stripCardAccountInput-eikia`,
	"stripCardExpiryInput": `Payment-stripCardExpiryInput-CiCpB`,
	"stripCardCvvInput": `Payment-stripCardCvvInput-KFWXA`,
	"stripCardOPostalInput": `Payment-stripCardOPostalInput-RNoYH`,
	"stripCardGridBox": `Payment-stripCardGridBox-c67fQ`,
	"gap12": `Payment-gap12-kFn06`,
	"cvvNoPadding": `Payment-cvvNoPadding-brapW`
};
module.exports = ___CSS_LOADER_EXPORT___;
